import { render, staticRenderFns } from "./UploadPostalCode.vue?vue&type=template&id=24c9373e&"
import script from "./UploadPostalCode.vue?vue&type=script&lang=js&"
export * from "./UploadPostalCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports